'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageProviderError = undefined;

var _StorageProviderError = require('./StorageProviderError');

Object.defineProperty(exports, 'StorageProviderError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StorageProviderError).default;
  }
});

var _cerebral = require('cerebral');

var _StorageProvider = require('./StorageProvider');

var _StorageProvider2 = _interopRequireDefault(_StorageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (options) {
  return (0, _cerebral.Module)(function (_ref) {
    var name = _ref.name,
        controller = _ref.controller;

    controller.once('initialized:model', function () {
      var targetStorage = options.target || localStorage;

      Object.keys(options.sync || {}).forEach(function (syncKey) {
        var value = targetStorage.getItem(options.prefix + syncKey);

        if (!value) {
          return;
        }

        var path = options.sync[syncKey].split('.');
        controller.model.set(path, options.json ? JSON.parse(value) : value);
      });
    });

    if (options.sync) {
      controller.on('flush', function (changes) {
        changes.forEach(function (change) {
          Object.keys(options.sync).forEach(function (syncKey) {
            if (change.path.join('.').indexOf(options.sync[syncKey]) === 0) {
              var value = controller.getState(options.sync[syncKey]);

              value === undefined ? options.target.removeItem(options.prefix + syncKey) : options.target.setItem(options.prefix + syncKey, options.json ? JSON.stringify(value) : value);
            }
          });
        });
      });
    }

    return {
      providers: _defineProperty({}, name, (0, _StorageProvider2.default)(options))
    };
  });
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/storage/lib/index.js
// module id = 1139
// module chunks = 5